import BossModel from "@/models/BossModel";
import moment from 'moment'
import User from "@/models/User/User";

export default class SaleTarget extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/sale-target';

    /**
     *
     * @type {string}
     */
    static entity = 'userSaleTargets';

    static fields() {
		return {
			id: this.number(null).nullable(),
			user_id: this.number(null).nullable(),
			start_date_at: this.attr(null),
			end_date_at: this.attr(null),
			amount: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
		}
	}

    /**
     *
     * @param userId
     * @param month
     * @param year
     * @returns {*}
     */
    static findByUser(userId, month, year) {
        return this.all().find(target => target.user_id == userId && target.start_date_at == year + '-' + month + '-01');
    }

    /**
     *
     * @param userId
     * @param month
     * @param year
     * @returns {*}
     */
    static loadFirstByUser(userId, month, year) {
        let date = moment(year + '-' + month).format('YYYY-MM');

        return this.api()
            .limit(1)
            .filtered({'date': date, 'user_id': userId})
            .first();
    }

    /**
     *
     * @param startDate
     * @param endDate
     * @param conditions
     * @returns {*}
     */
    static fetchPerMonth(startDate, endDate, conditions = {}) {
        return this.api().action('month')
            .filtered(conditions)
            .where('start_date', startDate)
            .where('end_date', endDate)
            .getSingle(false);
    }

    /**
     *
     * @param month
     * @param year
     * @returns {*}
     */
    static loadByMonth(month, year) {
        let date = moment(year + '-' + month).format('YYYY-MM');

        return this.api()
            .filtered({'date': date})
            .limit(0)
            .get();
    }
}
